export const jobService = {
  formatDateForDisplay(date) {
    if (!date) return "Date not available";

    const d = new Date(date);
    if (isNaN(d.getTime())) return "Invalid date";

    const day = d.getDate();
    const month = d.toLocaleDateString("en-US", { month: "short" });
    
    const getOrdinalSuffix = (num) => {
      const j = num % 10;
      const k = num % 100;
      if (j === 1 && k !== 11) return num + "st";
      if (j === 2 && k !== 12) return num + "nd";
      if (j === 3 && k !== 13) return num + "rd";
      return num + "th";
    };

    return `${getOrdinalSuffix(day)} ${month}`;
  },
};

